import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ExportOptionsService } from '../services/export-options.service';
import { NotificationService } from '@compumark/brand-context-components';
import { FilterParams } from 'src/app/results/services/filters.params';
import { DateFilterDialogComponent } from '../date-filter-dialog/date-filter-dialog.component';

@Component({
  selector: 'app-export-options-dialog',
  standalone: false,
  templateUrl: './export-options-dialog.component.html',
  styleUrls: ['./export-options-dialog.component.scss'],
})
export class ExportOptionsDialogComponent {
  dateFilterParams = FilterParams.dateFilterParams;
  exportForm: FormGroup;

  operator = 'inRange';
  from: Date | null = null;
  to: Date | null = null;
  dateType = '';

  constructor(
    private dialogRef: MatDialogRef<ExportOptionsDialogComponent>,
    private dialog: MatDialog,
    private exportService: ExportOptionsService,
    private fb: FormBuilder,
    private notificationService: NotificationService,
  ) {
    this.exportForm = this.fb.group({
      qualityCheck: [false],
      memberId: [''],
      analyst: [''],
      qualityAnalyst: [''],
    });
  }

  get displayedDateFilter(): string {
    const range = this.exportService.buildDateRange(
      this.operator,
      this.from,
      this.to,
    );
    if (!range) {
      return '';
    }

    const format = (iso: string) => new Date(iso).toLocaleDateString();

    if (range.startDate && range.endDate && range.startDate === range.endDate) {
      return `= ${format(range.startDate)}`;
    }

    if (range.startDate && !range.endDate) {
      return `> ${format(range.startDate)}`;
    }

    if (!range.startDate && range.endDate) {
      return `< ${format(range.endDate)}`;
    }

    if (range.startDate && range.endDate) {
      return `${format(range.startDate)} → ${format(range.endDate)}`;
    }

    return '';
  }

  openDateFilterDialog(): void {
    const ref = this.dialog.open(DateFilterDialogComponent, {
      width: '25rem',
      data: {
        operator: this.operator,
        from: this.from,
        to: this.to,
        filterOptions: this.dateFilterParams.filterOptions,
      },
    });

    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.operator = result.operator;
        this.from = result.from;
        this.to = result.to;
      }
    });
  }

  get isDeliveryDateValid(): boolean {
    if (this.dateType === '') {
      return false;
    }
    if (!this.from) {
      return false;
    }
    return this.operator !== 'inRange' || (!!this.from && !!this.to);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onExport(): void {
    if (!this.isDeliveryDateValid) {
      return;
    }

    const snackbarRef = this.notificationService.showSnackbar(
      'Your export file is being generated...',
      'DISMISS',
    );

    this.exportService
      .exportToXlsx(this.dateType, this.operator, this.from, this.to)
      .subscribe({
        next: (blob: Blob) => {
          this.exportService.triggerXLSXFileDownload(
            blob,
            'task-overview-export',
          );
          snackbarRef?.dismiss();
        },
      });
    this.dialogRef.close();
  }
}
